module.exports = __webpack_public_path__ + "img/logo.3bec5a92.png";